import {
	Directive,
	ElementRef,
	OnDestroy,
	HostBinding,
	ChangeDetectorRef,
	Input, OnChanges, SimpleChanges
} from '@angular/core';
import {takeUntilDestroy} from "take-until-destroy";
import {PopupType, PopupWindowService} from "../../services/popup.window.service";
import {Subscription} from "rxjs";

@Directive({
	selector: '[cpHideWhenPopupOpen]'
})
export class HideWhenPopupOpenDirective implements OnDestroy, OnChanges {
	@HostBinding("attr.aria-hidden") ariaHidden = false;

	@Input() popupType: PopupType = null;

	private subscription: Subscription = null;

	constructor(public elementRef: ElementRef, private changeDetector: ChangeDetectorRef,
	            private popupWindowService: PopupWindowService) {
		console.log("HideWhenPopupOpenDirective constructor", this.elementRef);

		this.subscription = this.popupWindowService.anyPopupsOpen.pipe(takeUntilDestroy(this)).subscribe((isPopupOpen) => {
			this.ariaHidden = isPopupOpen;
			this.changeDetector.markForCheck();
		});
	}

	public ngOnChanges(changes: SimpleChanges) {
		if (changes.popupType) {
			if (this.subscription) {
				this.subscription.unsubscribe();
			}

			if (this.popupType === null) {
				this.subscription = this.popupWindowService.anyPopupsOpen.pipe(takeUntilDestroy(this)).subscribe((isPopupOpen) => {
					this.ariaHidden = isPopupOpen;
					this.changeDetector.markForCheck();
				});
			} else {
				this.subscription = this.popupWindowService.isPopupsTypeOpen(this.popupType).pipe(takeUntilDestroy(this)).subscribe((isPopupOpen) => {
					this.ariaHidden = isPopupOpen;
					this.changeDetector.markForCheck();
				});
			}

		}
	}

	public ngOnDestroy(): void {

	}
}
